export type Locale = 'en-GB' | 'en-US' | 'nl'

/** IANA zone for next-intl — must be fixed so server/client date formatting matches. */
export const APP_TIME_ZONE = 'UTC'

export const LOCALES: { value: Locale; label: string }[] = [
  { value: 'en-GB', label: 'English (UK)' },
  { value: 'en-US', label: 'English (US)' },
  { value: 'nl', label: 'Nederlands' },
]

const STORAGE_KEY = 'locale'

export function getStoredLocale(): Locale | null {
  if (typeof window === 'undefined') return null
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored === 'en-GB' || stored === 'en-US' || stored === 'nl') return stored
  return null
}

export function setStoredLocale(locale: Locale): void {
  if (typeof window === 'undefined') return
  localStorage.setItem(STORAGE_KEY, locale)
}
